// src/ui/cx.ts (T1): joins class names, skipping falsy parts.
export function cx(...parts: (string | false | null | undefined | 0)[]): string {
  return parts.filter(Boolean).join(" ");
}
